import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const path = `m34.98,32c.56,0,1.02-.46,1.02-1.02V7.02c0-.56-.46-1.02-1.02-1.02H13.02c-.56,0-1.02.46-1.02,1.02v23.96c0,
    .56.46,1.02,1.02,1.02h.98v1.51h-.98c-.56,0-1.02.46-1.02,1.02v.44c0,.56.46,1.02,1.02,1.02h.98v5.02c0,.55.45,1,1,
    1h2c.55,0,1-.45,1-1v-5.02h4v2.02h4v-2.02h4v5.01c0,.55.45,1,1,1h1.99c.55,0,1-.45,1-1v-5.01h.98c.56,0,1.02-.46,
    1.02-1.02v-.44c0-.56-.46-1.02-1.02-1.02h-.98v-1.51h.98Zm-15.98,2.73c-.55,0-1-.45-1-1,0,.55-.45,1-1,1s-1-.45-1-1,
    .45-1,1-1,1,.45,1,1c0-.55.45-1,1-1s1,.45,1,1-.45,1-1,1Zm12,0c-.55,0-1-.45-1-1,0,.55-.45,1-1,1s-1-.45-1-1,.45-1,
    1-1,1,.45,1,1c0-.55.45-1,1-1s1,.45,1,1-.45,1-1,1Zm-.28-16.08h-1.28v5.14c0,.71-.58,1.28-1.28,1.28h-7.71c-.71,
    0-1.28-.58-1.28-1.29v-5.14h-1.28c-.39,0-.75-.18-1-.48-.44-.55-.36-1.36.2-1.81l6.42-5.14c.47-.37,1.14-.37,1.6,
    0l6.42,5.14c.3.24.48.61.48,1,0,.71-.57,1.29-1.28,1.29Z`

/**
 * Stateless function representing a trailer unload icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <TrailerUnloadIcon width={48} />
 */
const TrailerUnloadIcon = props => (
    <SvgIcon {...props}>
        <path d={path} />
    </SvgIcon>
)

TrailerUnloadIcon.defaultProps = defaultProps

export { TrailerUnloadIcon }
